/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import InputMask from 'react-input-mask';
import InputError from '../InputError/InputErrorComponent';
import ToolTip from '../Tooltip';

const FInput = ({
  id,
  label,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  placeholder,
  type,
  tests,
  cols,
  rows,
  maxLength,
  mask,
  info,
}) => {
  const required = tests && tests.find(test => test.OPTIONS.name === 'required');
  const hasValue = values[id] !== '' && values[id] !== undefined;
  const hasError = errors[id] !== undefined;
  const isTouched = touched[id];
  const isInvalid = isTouched && hasError ? 'is-invalid' : null;
  const className = info ? 'input-wrap has-info' : 'input-wrap';

  if (type === 'tel') {
    return (
      <div className={className}>
        <label htmlFor={id} className={`float ${hasValue && 'is-raised'}`}>
          <span className={`label-text ${hasError && hasValue ? 'is-invalid' : ''}`}>
            {label} {required && '*'}
          </span>
          <InputMask
            type={type || 'text'}
            className={['form-control', isInvalid].join(' ')}
            name={id}
            id={id}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={placeholder}
            value={values[id]}
            mask="999-999-9999"
            maskChar={null}
            pattern="^[2-9]\d{2}-\d{3}-\d{4}$"
          />
          <InputError touched={isTouched} message={errors[id]} />
        </label>
        {info && (
          <div className="tooltip-container">
            <ToolTip text={info} />
          </div>
        )}
      </div>
    );
  }

  if (type === 'textarea') {
    return (
      <div className={className}>
        <label htmlFor={id} className={`float ${hasValue && 'is-raised'}`}>
          <span className={`label-text ${hasError && hasValue ? 'is-invalid' : ''}`}>
            {label} {required && '*'}
          </span>
          <textarea
            className={['form-control', isInvalid].join(' ')}
            name={id}
            id={id}
            cols={cols}
            rows={rows}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={placeholder}
            value={values[id]}
          />
          <InputError touched={isTouched} message={errors[id]} />
        </label>
        {info && (
          <div className="tooltip-container">
            <ToolTip text={info} />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      <label htmlFor={id} className={`float ${hasValue && 'is-raised'}`}>
        <span className={`label-text ${hasError && hasValue ? 'is-invalid' : ''}`}>
          {label} {required && '*'}
        </span>
        <InputMask
          type={type || 'text'}
          className={['form-control', isInvalid].join(' ')}
          name={id}
          id={id}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          value={values[id]}
          maxLength={maxLength}
          mask={mask || null}
        />
        <InputError touched={isTouched} message={errors[id]} />
      </label>
      {info && (
        <div className="tooltip-container">
          <ToolTip text={info} />
        </div>
      )}
    </div>
  );
};

export default FInput;
